import classNames from "classnames";

import InputField from "../../../InputField";
import { DComponent } from "../../../DComponent";
import { GLOBAL_CONSTANTS } from "../../../../global/constants";
import { apiUpdateUserInfo } from "../../../../utils/api";
import RadioButton from "../../../RadioButton";
import DatePicker from "../../../DatePicker";

export default class UserInfo extends DComponent {
  constructor({
    parent,
    id,
    provider,
    name,
    email,
    onSubmit = () => { },
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("UserInfo", {

      }),
    });
    this.provider = provider;
    this.name = name;
    this.email = email;
    /** @type {InputField}*/
    this.nameField = undefined;
    /** @type {InputField}*/
    this.emailField = undefined;
    /** @type {RadioButton}*/
    this.genderField = undefined;
    /** @type {DatePicker}*/
    this.dateOfBirth = undefined;
    this.onSubmit = onSubmit;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "UserInfo");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.nameField = new InputField({
      parent: $(".input-list .name", this.element),
      label: "checkout_fullName",
      placeholder: "checkout_fullNamePlaceholder",
      invalid: "checkout_fullNameEnter",
      isRequired: true,
      defaultValue: this.name,
    })
    this.emailField = new InputField({
      parent: $(".input-list .email", this.element),
      label: "login_email",
      placeholder: "login_emailPlaceholder",
      invalid: "login_emailInvalid",
      isRequired: true,
      defaultValue: this.email,
      type: InputField.TYPE.EMAIL,
    })
    let listGender = [
      {
        label: "Male",
        label_vi: "Nam",
        value: "1"
      },
      {
        label: "Female",
        label_vi: "Nữ",
        value: "2"
      },
      {
        label: "Other",
        label_vi: "Khác",
        value: "3"
      }
    ];

    this.genderField = new RadioButton({
      parent: $(".input-list .gender", this.element),
      label: "login_gender",
      data: listGender,
      optionInline: true,
      selectedValue: listGender[0].value,
    });
    let currentYear = new Date().getFullYear();
    this.dateOfBirth = new DatePicker({
      parent: $(".input-list .dob", this.element),
      label: "login_dob",
      isFullField: true,
      yearRange: `${currentYear - 113}:${currentYear - 13}`,
      dateFormat: "yy-mm-dd",
      placeholderText: "YYYY-MM-DD",
    })
    this.addEvent();
  }

  addEvent() {
    $(".btn.save", this.element).on("click", (e) => {
      e.preventDefault();
      this.onSaveUserInfo();
    })
  }

  onSaveUserInfo() {
    if (this.validateForm()) {
      this.setLoading(true);

      let fullName = this.getName();
      let email = this.emailField.getValue();
      let gender = this.genderField.getValue();
      let dob = this.dateOfBirth.getDateFormat();
      let params = {
        full_name: fullName,
        email: email,
        gender: gender,
        dob: dob,
      };

      apiUpdateUserInfo(params,
        () => {
          this.setLoading(false);
          typeof this.onSubmit === "function" && this.onSubmit({
            fullName: fullName,
            email: email,
          },
            (error) => this.onError(error)
          );
        },
        (error) => {
          this.onError(error);
        }
      )
    }
  }

  onError(error) {
    $('.message', this.element).text(error && error.message ? error.message : GLOBAL_CONSTANTS.DEFAULT_ERROR);
    $('.message', this.element).addClass("error");
    this.setLoading(false);
  }

  showUserInfo() {
    this.nameField.focus();
  }

  validateForm() {
    let nameVal = this.nameField.isValidate();
    let emailVal = this.emailField.isValidate(true, nameVal);
    return nameVal && emailVal;
  }

  getName() {
    return this.nameField.getValue();
  }

  setName(name) {
    this.nameField.setValue(name);
  }

  setLoading(isLoading) {
    $(".btn.continue", this.element).toggleClass("loading", isLoading)
  }
}